import { unref as _unref, createVNode as _createVNode, isRef as _isRef, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc"
  }
};
import { onBeforeUnmount, shallowRef } from 'vue';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { useStore } from 'vuex';
import { useVModel } from '@vueuse/core';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css

const mode = 'default';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: [String, undefined],
      default: ''
    },
    width: {
      type: String,
      default: '500'
    },
    height: {
      type: String,
      default: '500'
    }
  },
  setup(__props) {
    const props = __props;
    const content = useVModel(props);

    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef();
    const toolbarConfig = {};
    const handleCreated = editor => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });
    const store = useStore();
    const editorConfig = {
      placeholder: '请输入内容...',
      MENU_CONF: {}
    };
    // 上传图片
    // eslint-disable-next-line
    editorConfig.MENU_CONF['uploadImage'] = {
      server: '/api/sys/v1/file/uploadFile',
      // server: '/api/upload-img-10s', // test timeout
      // server: '/api/upload-img-failed', // test failed
      // server: '/api/xxx', // test 404
      timeout: 5 * 1000,
      // 5s
      fieldName: 'file',
      metaWithUrl: true,
      // join params to url
      headers: {
        // Accept: 'text/x-json',
        Authorization: `Bearer ${store.getters.token}`
      },
      maxFileSize: 2 * 1024 * 1024,
      // 10M
      base64LimitSize: 5 * 1024,
      // insert base64 format, if file's size less than 5kb

      // 上传之前触发
      onBeforeUpload(file) {
        // console.log('onBeforeUpload', file)
        return file; // will upload this file
        // return false // prevent upload
      },
      // 上传进度的回调函数
      onProgress(progress) {
        // console.log('onProgress', progress)
      },
      // 单个文件上传成功之后
      onSuccess(file, res) {
        // console.log('onSuccess', file, res)
      },
      // 单个文件上传失败
      onFailed(file, res) {
        alert(res.message);
        // console.log('onFailed', file, res)
      },
      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        alert(err.message);
        console.error('onError', file, err, res);
      },
      // 自定义插入图片
      customInsert(res, insertFn) {
        // TS 语法
        // customInsert(res, insertFn) {                  // JS 语法
        // res 即服务端的返回结果
        // 从 res 中找到 url alt href ，然后插入图片
        insertFn(res.data, 'image', res.data);
      }
    };

    // eslint-disable-next-line
    editorConfig.MENU_CONF['insertVideo'] = {
      onInsertedVideo(videoNode) {
        console.log('inserted video', videoNode);
      }
    };

    // 上传视频
    // eslint-disable-next-line
    editorConfig.MENU_CONF['uploadVideo'] = {
      server: '/api/sys/v1/file/uploadFile',
      // server: '/api/upload-img-failed', // test failed
      // server: '/api/xxx', // test 404

      timeout: 5 * 1000,
      // 5s

      fieldName: 'file',
      // meta: { token: store.getters.token },
      metaWithUrl: true,
      // join params to url
      headers: {
        Authorization: `Bearer ${store.getters.token}`
      },
      maxFileSize: 100 * 1024 * 1024,
      // 100M

      onBeforeUpload(file) {
        console.log('onBeforeUpload', file);
        return file; // will upload this file
        // return false // prevent upload
      },
      onProgress(progress) {
        console.log('onProgress', progress);
      },
      onSuccess(file, res) {
        console.log('onSuccess', file, res);
      },
      onFailed(file, res) {
        alert(res.message);
        console.log('onFailed', file, res);
      },
      onError(file, err, res) {
        alert(err.message);
        console.error('onError', file, err, res);
      },
      // 自定义插入视频
      customInsert(res, insertFn) {
        // TS 语法
        // customInsert(res, insertFn) {                  // JS 语法
        // res 即服务端的返回结果
        console.log(res);
        // 从 res 中找到 url poster ，然后插入视频
        insertFn(res.data);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
        style: {
          "border-bottom": "1px solid #ccc"
        },
        editor: editorRef.value,
        defaultConfig: toolbarConfig,
        mode: mode
      }, null, 8, ["editor"]), _createVNode(_unref(Editor), {
        style: _normalizeStyle({
          height: __props.height + 'px',
          maxWidth: '100%'
        }),
        modelValue: _unref(content),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(content) ? content.value = $event : null),
        defaultConfig: editorConfig,
        mode: mode,
        onOnCreated: handleCreated
      }, null, 8, ["style", "modelValue"])]);
    };
  }
};